import React, { useState, useEffect } from 'react';
import './FloatingWhats.css';
import whatsIcon from '../../assets/botao-zap.webp';

const FloatingWhats = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const sobreSection = document.getElementById('sobre');
            if (!sobreSection) return;

            const { top, bottom } = sobreSection.getBoundingClientRect();

            const isVisibleNow = top < window.innerHeight && bottom >= 0;
            const isBelow = bottom < 0;

            setIsVisible(isVisibleNow || isBelow);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // já avalia na primeira renderização

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const openWhatsApp = () => {
        const whatsappLink =
            'https://api.whatsapp.com/send?phone=5511943421608&text=Oi,%20vi%20o%20seu%20site%20pelo%20Google%20e%20tenho%20interesse%20em%20come%C3%A7ar%20o%20processo%20terap%C3%AAutico.%20Como%20podemos%20dar%20o%20primeiro%20passo%3F';

        window.open(whatsappLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <button
            className={`whatsapp-button ${!isVisible ? 'whatsapp-button-fade' : ''}`}
            onClick={openWhatsApp}
            aria-label="Falar pelo WhatsApp"
        >
            <img src={whatsIcon} alt="" aria-hidden="true" />
        </button>
    );
};

export default FloatingWhats;
